import * as React from 'react';
import { CommonRootState } from '@pec/aion-ui-core/combineReducers';
import { connect } from 'react-redux';
import { fetchSafetyProgramsNotificationsCount } from '@pec/aion-ui-core/actions/fetchSafetyProgramsNotificationsCount';
import { Location } from 'history';
import { RootActions } from '@pec/aion-ui-core/combineActions';
import { SafetyProgramsComponent } from '../../components/Nav/SafetyPrograms';
import { ThunkDispatch } from 'redux-thunk';

type OwnProps = {
  navExpanded: boolean;
  organizationId: string;
  location: Location;
};

const mapStateToProps = ({ notifications: { safetyPrograms } }: CommonRootState) => ({
  notificationCount: safetyPrograms
});

const mapDispatchToProps = (
  dispatch: ThunkDispatch<CommonRootState, null, RootActions>,
  { organizationId }: OwnProps
) => ({
  fetchSafetyProgramsNotificationsCount: () => dispatch(fetchSafetyProgramsNotificationsCount(organizationId))
});

type Props = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps> & OwnProps;

class SafetyPrograms extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    props.fetchSafetyProgramsNotificationsCount();
  }

  render() {
    const { navExpanded, organizationId, notificationCount } = this.props;

    return (
      <SafetyProgramsComponent
        navExpanded={navExpanded}
        organizationId={organizationId}
        notificationCount={notificationCount}
      />
    );
  }
}

export const SafetyProgramsContainer = connect(mapStateToProps, mapDispatchToProps)(SafetyPrograms);
